export default "__VITE_ASSET__Dho_qF9c__"